// These are default Tebra constants used as fallback for the CSS Variables
const defaults = {
  fontFamily: `"Akkurat LL", "Helvetica - Neue", Helvetica, Arial`,

  primaryColor: '#004852', // growth 1
  primaryColorDark: '#004852', // growth 1
  primaryColorLight: '#417E86', // growth 2
  primaryColor200: '#8CB2B6', // growth 3
  primaryColor100: '#CBDDE0', // growth 4

  secondaryColor: '#D83B4D', // first aid
  secondaryColorDark: '#B51A2C', // remedy
  secondaryColorLight: '#FBCBD1', // siren

  vitalityColor: '#FF8D6E', // vitality 1
  vitalityColorDark: '#DC785D', // vitality 0
  vitalityColorLight: '#FFAF95', // vitality 2
  vitalityColor200: '#FFCFBF', // vitality 3
  vitalityColor100: '#FFE9E3', // vitality 4

  coreColor: '#8CA7A2', // core 1
  coreColorLight: '#B3C6C4', // core 2
  coreColor200: '#D4E0DD', // core 3
  coreColor100: '#E9EFEE', // core 4

  backboneColor: '#E8E5DF', // backbone 3
  backboneColorLight: '#F0EEE8', // backbone 2
  backboneColorDark: '#E1DED8', // backbone 4

  activeColor: '#067889', // practice
  dividerColor: '#D6D6D6', // synapse 4
  hoverColor: '#EEF7F9', // growth 5
  selectedColor: '#F6F3EB', // backbone 1
  focusColor: '#E6F5F7', // pneumo

  infoColor: '#4678CC', // circadian
  infoColorDark: '#067889', // practice
  infoColorLight: '#83CDD9', // placebo

  errorColor: '#D83B4D', // first aid
  errorColorDark: '#B51A2C', // remedy
  errorColorLight: '#FCEEEE', // plasma

  warningColor: '#FCDE73', // energize
  warningColorDark: '#F2BA2A', // neuron
  warningColorLight: '#FEF5D5', // amino

  successColor: '#2B865A', // vigor
  successColorDark: '#1D6B45', // soma
  successColorLight: '#F0FAF2', // asana

  dataVisSuccessColor: '#3FA266', // cyto
  dataVisInfoColor: '#079CB2', // holistic

  backgroundPaperColor: '#FBF9F8', // care 4
  backgroundPrimaryColor: '#E9EFEE', // core 4

  textColorPrimary: '#000',
  textColorSecondary: '#545454', // synapse 2
  textColorDisabled: '#9a9a9a', // synapse 3

  black: '#000',
  white: '#fff',

  grey900: '#2b2b2b', // synapse 1
  grey600: '#545454', // synapse 2
  grey500: '#9a9a9a', // synapse 3
  grey400: '#d6d6d6', // synapse 4
  grey300: '#F6F6F6', // synapse 5

  providerProfilePrimaryColor: '#004852', // growth 1
  providerProfilePrimaryColorLight: '#8CB2B6', // growth 3
};

export default defaults;
